import { render, staticRenderFns } from "./AsignacionTurno.vue?vue&type=template&id=76a0e5be&scoped=true"
import script from "./AsignacionTurno.vue?vue&type=script&lang=js"
export * from "./AsignacionTurno.vue?vue&type=script&lang=js"
import style0 from "./AsignacionTurno.vue?vue&type=style&index=0&id=76a0e5be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a0e5be",
  null
  
)

export default component.exports